import * as React from "react";
import { Stack } from "@mui/material";
import ReportTable from "../tables/ReportTable";
import ReportsFilter from "../filters/ReportsFilter";
import { useHasScope } from "../../../../../config/globalConfig";
import { VIEW_PRINTOUTS_HISTORY, VIEW_ROYALTIES_REPORTS } from "../../../utils/FinanceScope";
import NotAuthorizedDialog from "../../../../authentication/component/NotAuthorizedDialog";

function Reports() {

    const hasScope = useHasScope;

    if (!hasScope(VIEW_ROYALTIES_REPORTS) && !hasScope(VIEW_PRINTOUTS_HISTORY)) return <NotAuthorizedDialog />

    return (
        <Stack direction={"column"} spacing={2} margin={"16px"}>
            <ReportsFilter/>
            <ReportTable/>
        </Stack> 
    )
}

export default Reports;